<template>
    <v-card :loading="loading">
        <v-card-title class="text-h5">
            <v-btn
                small
                icon
                @click="close"
                color="primary"
                class="ml-n3 mr-2 my-2 py-0"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            Scheduling Details - WO {{ workOrder.code }} <v-spacer /><v-btn
                rounded
                @click="openExistentPackingListsDialog()"
                color="primary"
                class="ml-n3 mr-2 my-2 py-0"
            >
                Open Existent Packing List </v-btn
            ><v-btn
                rounded
                @click="createPL()"
                color="primary"
                class="ml-3 mr-2 my-2 py-0"
            >
                New Packing List
            </v-btn></v-card-title
        >
        <v-divider class="ml-4 mr-5 mb-2" />
        <v-card-text>
            <v-data-table
                id="virtual-scroll-table"
                disable-pagination
                hide-default-footer
                :headers="headers"
                :items="workOrder.items"
                class="elevation-0"
                :mobile-breakpoint="0"
                fixed-header
                :height="$vuetify.breakpoint.mdAndDown ? '65vh' : '65vh'"
                :loading="loading"
                multiple-expand
                :expanded.sync="expanded"
                show-expand
            >
                <template v-slot:top>
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pb-0 align-center"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <v-col cols="9">
                            <h2 class="ml-4">Work Order Items</h2>
                            <v-spacer />
                        </v-col>
                    </v-row>
                </template>
                <!--ITEMS-->
                <template v-slot:[`item.partNumber`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.partNumber }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.totalPacked`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.totalPacked }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.nextDelivery`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{
                                item.nextDelivery
                                    ? formatDate(item.nextDelivery)
                                    : '-'
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.schedulingProgress`]="{ item }">
                    <div class="d-flex justify-center">
                        <v-progress-linear
                            v-model="item.schedulingProgress"
                            height="25"
                            :color="getProgressColor(item.schedulingProgress)"
                            rounded
                            class="no-interaction"
                        >
                            <strong
                                >{{
                                    item.schedulingProgress.toFixed(2)
                                }}%</strong
                            >
                        </v-progress-linear>
                    </div>
                </template>
                <template v-slot:[`item.packingProgress`]="{ item }">
                    <div class="d-flex justify-center">
                        <v-progress-linear
                            v-model="item.packingProgress"
                            height="25"
                            :color="getProgressColor(item.packingProgress)"
                            rounded
                            class="no-interaction"
                        >
                            <strong
                                >{{ item.packingProgress.toFixed(2) }}%</strong
                            >
                        </v-progress-linear>
                    </div>
                </template>
                <template v-slot:[`item.shippingProgress`]="{ item }">
                    <div class="d-flex justify-center">
                        <v-progress-linear
                            v-model="item.shippingProgress"
                            height="25"
                            :color="getProgressColor(item.shippingProgress)"
                            rounded
                            class="no-interaction"
                        >
                            <strong
                                >{{ item.shippingProgress.toFixed(2) }}%</strong
                            >
                        </v-progress-linear>
                    </div>
                </template>
                <template
                    v-slot:expanded-item="{
                        headers,
                        item: item,
                    }"
                >
                    <td
                        :colspan="headers.length"
                        class="pa-4 ma-0 outlined"
                        :style="{ background: 'white' }"
                    >
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="subheaders"
                                    :items="item.packingInformation"
                                    class="elevation-0"
                                    :mobile-breakpoint="0"
                                    :loading="loading"
                                    disable-pagination
                                    hide-default-footer
                                >
                                    <!--ITEMS-->
                                    <template v-slot:[`item.status`]="{ item }">
                                        <div class="d-flex justify-center">
                                            <v-chip
                                                :color="
                                                    statusColor[item.status]
                                                "
                                                class="white--text text-capitalize"
                                            >
                                                {{
                                                    item.status == 'referred'
                                                        ? 'inDelivery'
                                                        : item.status
                                                }}
                                            </v-chip>
                                        </div>
                                    </template>
                                    <template
                                        v-slot:[`item.airShipment`]="{ item }"
                                    >
                                        <div class="d-flex justify-center">
                                            <v-chip
                                                :color="
                                                    item.airShipment
                                                        ? 'primary'
                                                        : 'black'
                                                "
                                                class="white--text text-capitalize"
                                            >
                                                {{
                                                    item.airShipment
                                                        ? 'Yes'
                                                        : 'No'
                                                }}
                                            </v-chip>
                                        </div>
                                    </template>
                                    <template
                                        v-slot:[`item.actions`]="{ item }"
                                    >
                                        <div class="d-flex justify-center">
                                            <v-btn
                                                small
                                                icon
                                                @click="
                                                    openProcessPackingList(item)
                                                "
                                            >
                                                <v-icon>{{
                                                    [
                                                        'rejected',
                                                        'inProgress',
                                                    ].includes(item.status)
                                                        ? 'mdi-pencil'
                                                        : 'mdi-eye'
                                                }}</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
        <!--PACKING ORDER FORM-->
        <v-dialog
            v-model="packingListForm"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <PackingForm
                v-if="packingListForm"
                :project="selectedProject"
                :originalOrder="selectedOrder"
                :onlySuggested="true"
                @close="closePackingListForm"
                @addPackingList="addPackingList"
                @replacePackingList="replacePackingList"
            />
        </v-dialog>
        <!--PROCESS PACKING ORDER-->
        <v-dialog
            v-model="processPackingList"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <ProcessPackingPending
                v-if="processPackingList && selectedOrder.status == 'pending'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                @close="closeProcessPackingList"
                @replacePackingList="replacePackingList"
            />
            <ProcessPackingScheduled
                v-if="processPackingList && selectedOrder.status == 'scheduled'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                @close="closeProcessPackingList"
                @replacePackingList="replacePackingList"
            />
            <ProcessPackingReferred
                v-if="processPackingList && selectedOrder.status == 'referred'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                @close="closeProcessPackingList"
                @replacePackingList="replacePackingList"
            />
            <ProcessPackingShipped
                v-if="processPackingList && selectedOrder.status == 'shipped'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                @close="closeProcessPackingList"
                @replacePackingList="replacePackingList"
            />
            <ProcessPackingCompleted
                v-if="processPackingList && selectedOrder.status == 'completed'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                @close="closeProcessPackingList"
            />
        </v-dialog>
        <!--EXISTENT PACKING LISTS-->
        <v-dialog
            v-model="openExistentPackingLists"
            :retain-focus="false"
            persistent
            width="600px"
        >
            <ExistentPackingLists
                v-if="openExistentPackingLists"
                :onlySuggested="true"
                :currentUser="user"
                :packingLists="packingLists"
                :project="selectedProject"
                @close="openExistentPackingLists = false"
                @openProcessPackingList="openProcessPackingList"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import API from '@/services/api'

export default {
    name: 'WOPlannerDetails',
    components: {
        PackingForm: () => import('@/components/Packing/PackingForm.vue'),
        ProcessPackingPending: () =>
            import('@/components/Packing/ProcessPackingPending.vue'),
        ProcessPackingScheduled: () =>
            import('@/components/Packing/ProcessPackingScheduled.vue'),
        ProcessPackingReferred: () =>
            import('@/components/Packing/ProcessPackingReferred.vue'),
        ProcessPackingShipped: () =>
            import('@/components/Packing/ProcessPackingShipped.vue'),
        ProcessPackingCompleted: () =>
            import('@/components/Packing/ProcessPackingCompleted.vue'),
        ExistentPackingLists: () =>
            import('@/components/ShipmentPlanner/ExistentPackingLists.vue'),
    },
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        projects: { type: Array, required: true },
        packingLists: { type: Array, required: true },
    },

    data: () => ({
        loading: false,
        expanded: [],
        countryName: 'colombia',
        headers: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
                width: 150,
            },
            {
                text: 'QTY',
                value: 'quantity',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PACKED QTY',
                value: 'totalPacked',
                align: 'center',
                sortable: false,
                width: 105,
            },
            {
                text: 'SCHEDULED QTY',
                value: 'scheduledQty',
                align: 'center',
                sortable: false,
                width: 130,
            },
            {
                text: 'SHIPPED QTY',
                value: 'shippedQty',
                align: 'center',
                sortable: false,
                width: 130,
            },
            {
                text: 'NEXT DELIVERY',
                value: 'nextDelivery',
                align: 'center',
                sortable: true,
                width: 140,
            },
            {
                text: 'PACKING PROGRESS',
                value: 'packingProgress',
                align: 'center',
                sortable: true,
                width: 200,
            },
            {
                text: 'SCHEDULING PROGRESS',
                value: 'schedulingProgress',
                align: 'center',
                sortable: true,
                width: 200,
            },
            {
                text: 'SHIPPING PROGRESS',
                value: 'shippingProgress',
                align: 'center',
                sortable: true,
                width: 200,
            },
        ],
        subheaders: [
            {
                text: 'PACKING LIST',
                value: 'packingListCode',
                align: 'center',
                sortable: false,
            },
            {
                text: 'STATUS',
                value: 'status',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PACKED QTY',
                value: 'packingQty',
                align: 'center',
                sortable: true,
            },
            {
                text: 'REQUESTED SHIPMENT DATE',
                value: 'requestedShipmentDate',
                align: 'center',
                sortable: true,
            },
            {
                text: 'SCHEDULED FOR',
                value: 'scheduledFor',
                align: 'center',
                sortable: true,
            },
            {
                text: 'AIR SHIPMENT',
                value: 'airShipment',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        statusColor: {
            inProgress: '#9E9FA0',
            pending: '#FF9800',
            referred: 'primary',
            scheduled: '#25539d',
            rejected: 'red',
            completed: 'black',
            shipped: '#27BC4F',
        },

        selectedProject: {},
        selectedOrder: {},
        packingListForm: false,
        processPackingList: false,
        createPackingList: false,
        openExistentPackingLists: false,
    }),
    async mounted() {},
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('close')
        },
        getProgressColor(percentage) {
            if (percentage < 25) return 'error'
            if (percentage < 50) return 'orange'
            if (percentage < 75) return 'warning'
            if (percentage < 100) return 'info'
            return 'success'
        },
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        async openProcessPackingList(item) {
            try {
                this.loading = true
                if (item.status != 'completed') {
                    this.selectedOrder = await API.getPackingLists({
                        projectId: this.workOrder.projectId,
                        id: item.packingListId,
                    })
                } else {
                    this.selectedOrder = this.packingLists.find(
                        pl => pl.id == item.packingListId
                    )
                }

                this.selectedProject = _.cloneDeep(
                    this.findProject(this.workOrder.projectId)
                )
                if (item.status == 'inProgress' || item.status == 'rejected') {
                    this.packingListForm = true
                } else {
                    this.processPackingList = true
                }
                this.openExistentPackingLists = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        findProject(id) {
            let project = { reference: '', name: '' }
            const projectFound = this.projects.find(p => p.id == id)
            if (projectFound) {
                project = projectFound
            }
            return project
        },
        closePackingListForm() {
            this.selectedOrder = null
            this.selectedProject = null
            this.packingListForm = false
        },
        closeProcessPackingList() {
            this.selectedOrder = null
            this.selectedProject = null
            this.processPackingList = false
        },
        openExistentPackingListsDialog() {
            this.selectedProject = _.cloneDeep(
                this.findProject(this.workOrder.projectId)
            )
            this.openExistentPackingLists = true
        },
        createPL() {
            this.selectedProject = _.cloneDeep(
                this.findProject(this.workOrder.projectId)
            )
            this.selectedOrder = null
            this.createPackingList = false
            this.packingListForm = true
        },
        addPackingList(packingList) {
            let alertMessage = ''
            const plProject = this.findProject(packingList.projectId)

            if (!packingList.selectedWorkOrders && !packingList.selectedBOMs) {
                if (
                    plProject.country &&
                    plProject.country.toLowerCase() == this.countryName
                ) {
                    alertMessage = `New Packing List ${packingList.code} Successfully Created As Domestic Shipping`
                } else {
                    alertMessage = `New Packing List ${packingList.code} Successfully Created As Reserved For Project. For more information see the packing list section in the project details`
                }
            } else if (
                !packingList.packages ||
                packingList.packages.length == 0
            ) {
                if (
                    plProject.country &&
                    plProject.country.toLowerCase() == this.countryName
                ) {
                    alertMessage = `New Packing List ${packingList.code} Successfully Created As Domestic Shipping`
                } else {
                    alertMessage = `New Packing List ${packingList.code} Successfully Created As Reserved. For more information see the packing list section in the project details`
                }
            } else {
                alertMessage = `New Packing List Successfully Created`
                this.packingLists.push(packingList)
            }

            this.$emit('addPackingList', {
                alertMessage,
                packingList,
            })
        },
        replacePackingList(packingList) {
            this.$emit('replacePackingList', packingList)
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
.v-data-table {
    border: 1px solid #eeeeee;
}
</style>
